// src/pages/routes/App.tsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Signup from "../features/Signup";
import SignIn from "../features/SignIn";
import ForgotPassword from "../features/ForgotPassword";
import AuthAction from "../features/AuthAction";
import Dashboard from "../Dashboard";
import Inbox from "../messaging/Inbox";
import PenPalBoard from "../board/PenPalBoard";
import SafetyRules from "../Rules";
import MessagesForm from "../messaging/MessagesForm";
import Profile from "../Profile";
import PublicProfile from "../PublicProfile";
import PenPalRequests from "../requests/PenPalRequestsPage";
import SingleAd from "../board/SingleAd";
import PenPalDirectory from "../board/PenPalDirectory";
import AddressBook from "../AddressBook";
import Community from "../Community";
import Room from "../community/Room";
import ThreadPage, { CirclePostPage, PiecePage } from "../community/ThreadPage";
import PostFront from "../post/PostFront";
import SubmitPiece from "../post/SubmitPiece";
import SortingRoom from "../post/SortingRoom";
import Circles from "../community/Circles";
import CirclePage from "../community/CirclePage";

import Welcome from "../Welcome";
import Privacy from "../Privacy";
import Care from "../Care";
import WhoWeAre from "../WhoWeAre";
import GetInvolved from "../GetInvolved";

import Layout from "../../components/Layout";
import PublicShell from "../../components/PublicShell";
import ProtectedRoute from "../../components/ProtectedRoute";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../styles.css";

// The front door: members go to their home page, visitors to the welcome page.
function Home() {
  const [user, loading] = useAuthState(auth);
  if (loading) return null;
  return <Navigate to={user ? "/dashboard" : "/welcome"} replace />;
}

export default function App() {
  return (
    <Router>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/welcome" element={<PublicShell><Welcome /></PublicShell>} />
        <Route path="/guidelines" element={<PublicShell><SafetyRules /></PublicShell>} />
        <Route path="/privacy" element={<PublicShell><Privacy /></PublicShell>} />
        <Route path="/care" element={<PublicShell><Care /></PublicShell>} />
        <Route path="/who-we-are" element={<PublicShell><WhoWeAre /></PublicShell>} />
        <Route path="/get-involved" element={<PublicShell><GetInvolved /></PublicShell>} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth-action" element={<AuthAction />} />

        {/* PROTECTED ROUTES WITH LAYOUT */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/send" element={<MessagesForm />} />
          <Route path="/board" element={<PenPalBoard />} />
          <Route path="/ad/:id" element={<SingleAd />} />
          <Route path="/rules" element={<SafetyRules />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile/:id" element={<PublicProfile />} />
          <Route path="/requests" element={<PenPalRequests />} />
          <Route path="/board/directory" element={<PenPalDirectory />} />
          <Route path="/address-book" element={<AddressBook />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/thread/:threadId" element={<ThreadPage />} />
          <Route path="/circles" element={<Circles />} />
          <Route path="/post" element={<PostFront />} />
          <Route path="/post/submit" element={<SubmitPiece />} />
          <Route path="/post/sorting" element={<SortingRoom />} />
          <Route path="/post/:pieceId" element={<PiecePage />} />
          <Route path="/circles/:circleId" element={<CirclePage />} />
          <Route path="/circles/:circleId/post/:postId" element={<CirclePostPage />} />
          <Route path="/community/:roomId" element={<Room />} />
        </Route>

        {/* anything else (including the retired /community pages) goes home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer />
    </Router>
  );
}
